/**
 * URLs des actions globales sur les threads (hors route `{page}/session_manager/...`).
 * Gère `API_BASE_URL` avec ou sans suffixe `/api`.
 */
export function threadsDeleteUrl(threadsEndpoint: string): string {
  const u = new URL(
    threadsEndpoint,
    typeof window !== "undefined" ? window.location.href : "http://localhost"
  );
  let path = u.pathname.replace(
    /\/[^/]+\/session_manager\/thread_ids\/?$/,
    ""
  );
  path = path.replace(/\/$/, "") || "";
  if (!path || path === "/") {
    u.pathname = "/api/threads/delete";
  } else if (path === "/api" || path.endsWith("/api")) {
    u.pathname = `${path}/threads/delete`;
  } else {
    u.pathname = `${path}/api/threads/delete`;
  }
  return u.toString();
}

export function threadsRenameUrl(threadsEndpoint: string): string {
  return threadsDeleteUrl(threadsEndpoint).replace(/\/delete\/?$/, "/rename");
}
